import { useEffect } from 'react';
import secureLocalStorage from 'react-secure-storage';
import { logoutUser } from '../util/util';
import { refreshAuthToken } from '../util/authTokens';

/**
 * Periodically check session expiry and force logout when expired
 * @param {number} checkIntervalMs - how often to check (default 10000ms)
 */
export const useSessionExpiry = (checkIntervalMs = 10000) => {
  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      const expiresAt = secureLocalStorage.getItem('expiresAt');
      const now = Date.now();
      const expiry = parseInt(expiresAt, 10);
      if (!expiry) return;

      // Refresh when token is expired or within 30s of expiry.
      if (expiry <= now + 30000) {
        try {
          await refreshAuthToken();
        } catch (e) {
          if (!cancelled) logoutUser();
        }
      }
    };

    check(); // check immediately on mount
    const id = setInterval(() => { void check(); }, checkIntervalMs);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [checkIntervalMs]);
};

export default useSessionExpiry;
